module.exports = __webpack_public_path__ + "static/media/pasamosagosto5.791c4da2.jpg";